import { useHubspotAhoyProperties } from '../hooks/useHubspotAhoyProperties';
import { HubspotFieldMappingManager } from './HubspotFieldMappingManager';

interface HubspotMappingsManagerViewProps {
  orgId: number | string;
  connected: boolean;
  onBack?: () => void;
}

export function HubspotMappingsManagerView({
  orgId,
  connected,
  onBack,
}: HubspotMappingsManagerViewProps) {
  const availablePropertiesByObject = useHubspotAhoyProperties(orgId);

  return (
    <HubspotFieldMappingManager
      orgId={orgId}
      availablePropertiesByObject={availablePropertiesByObject}
      connected={connected}
      onBack={onBack}
    />
  );
}
